<template>

  <app-layout>

    <main class="max-w-7xl mx-auto pb-10 lg:py-12 lg:px-8">


      <div class="relative bg-white">
        <div class="absolute inset-0">
          <div class="absolute inset-y-0 left-0 w-1/2 bg-gray-50"/>
        </div>
        <div class="relative max-w-7xl mx-auto lg:grid lg:grid-cols-5">
          <div class="bg-blue-50 py-16 px-4 sm:px-6 lg:col-span-2 lg:px-8 lg:py-24 xl:pr-12">
            <div class="max-w-lg mx-auto">
              <h2 class="text-2xl font-extrabold tracking-tight text-gray-900 sm:text-3xl">
                About Us
              </h2>

              <p class="mt-3 text-lg leading-6 text-gray-500">
                AgileSuite started as a side project from <label class="text-blue-400 font-bold">Ryan Deng</label> back
                in 2019. The site is designed for those agile teams to gain more agile assistant. The product is differentiate from others as it provides All-in-One package that allows your team to focus in one dashboard with less cost.
              </p>

              <div class="mt-5">
                <label class="text-blue-400 font-bold">Ryan Deng (Co-founder)</label>

                <a target="_blank" href="https://www.linkedin.com/in/ryandeng"
                   class="text-pink-500 background-transparent font-bold uppercase px-3 py-1 text-xs outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                   type="button"
                >
                  Linkedin
                </a>
              </div>

              <div class="mt-2 mb-5">
                <label class="text-blue-400 font-bold">Kerry Zhang (Co-founder)</label>
                <a target="_blank" href="https://www.linkedin.com/in/xiongpan-zhang-830858171/"
                   class="text-pink-500 background-transparent font-bold uppercase px-3 py-1 text-xs outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                   type="button"
                >
                  Linkedin
                </a>
              </div>


              <div class="mt-3">
                <dt class="sr-only">Email</dt>
                <dd class="flex">
                  <MailIcon class="flex-shrink-0 h-6 w-6 text-gray-400" aria-hidden="true"/>
                  <span class="ml-3">
                  agilehrsuite@gmail.com
                </span>
                </dd>
              </div>

            </div>
          </div>
          <div class="bg-white py-16 px-4 sm:px-6 lg:col-span-3 lg:py-24 lg:px-8 xl:pl-12">
            <div class="max-w-lg mx-auto lg:max-w-none">
              <form action="#" method="POST" class="grid grid-cols-1 gap-y-6">
                <div>
                  <label for="full_name" class="sr-only">Full name</label>
                  <input v-model="this.form.name" type="text" name="full_name" id="full_name" autocomplete="name"
                         class="block w-full shadow-sm py-3 px-4 placeholder-gray-500 focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md"
                         placeholder="Full name"/>
                </div>
                <div>
                  <label for="email" class="sr-only">Email</label>
                  <input v-model="this.form.email" id="email" name="email" type="email" autocomplete="email"
                         class="block w-full shadow-sm py-3 px-4 placeholder-gray-500 focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md"
                         placeholder="Email"/>
                </div>
                <div>
                  <label for="message" class="sr-only">Message</label>
                  <textarea v-model="this.form.message" id="message" name="message" rows="4"
                            class="block w-full shadow-sm py-3 px-4 placeholder-gray-500 focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md"
                            placeholder="Message"/>
                </div>


                <a-spin :spinning="submittingFeedback">
                  <button
                      @click.prevent="submitFeedback"
                      type="button"
                      class="
                    rounded-full
                    transition
                    duration-200
                    bg-yellow-400
                    hover:bg-yellow-300
                    focus:outline-none
                    text-black
                    w-full
                    py-2.5
                    rounded-lg
                    text-lg
                    font-semibold
                    text-center
                    inline-block
                  "
                  >
                    <span class="inline-block mr-2">Contact Us</span>
                  </button>
                </a-spin>
              </form>
            </div>
          </div>
        </div>
      </div>
    </main>
  </app-layout>
</template>

<script>
import {MailIcon, PhoneIcon} from '@heroicons/vue/outline'
import AppLayout from "@/Layouts/AppLayout";
import {message} from "ant-design-vue";

export default {
  components: {
    AppLayout,
    MailIcon,
    PhoneIcon,
  },
  data() {
    return {
      submittingFeedback: false,
      form:{
        name: '',
        message: '',
        email: '',
      }
    };
  },
  methods:{
    submitFeedback(){
      let app = this;
      app.submittingFeedback = true;
      axios
          .post(route("contact-us"), {
            name: this.form.name,
            message: this.form.message,
            email: this.form.email,
          })
          .then((response) => {
            message.success("Thank you for contacting us, we will reach you as soon as possible.", 5);
            app.submittingFeedback = false;
          })
          .catch((error) => {
            message.error(
                "You attempted too many times or we experience an error.",
                5
            );
            app.submittingFeedback = false;
          });
    }
  }
}
</script>
